import { Postagens } from '../../../services/http'
import { getMinDate } from '../../../pages/postagens/functions'
const getPostagens = async filter => {
  const date = getMinDate()

  const { data } = await Postagens().show({
    per_page: -1,
    'includes[]': 'obra.categoriaObra',
    ano_id: date.getFullYear(),
    status_postagem_id: 2,
    ...filter
  })
  return data.data
}

export default getPostagens
